import MapPercentage from "@app/core/models/map-percentage.model";

export const MAP_PERCENTAGE_MOCK: MapPercentage[] = [
  { name: 90 },
  { name: 95 },
  { name: 99 }
]
